export default "__VITE_ASSET__DEDtecBj__"